(function () {
  var root = document.querySelector('[data-pr-bundle-product]');
  if (!root) return;

  var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';

  // Minimal Shopify-style money formatter — covers the placeholders every default
  // money_format uses ({{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}}).
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var noDecimals = parts[0];
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ',' + parts[1];
    return (format || '{{amount}}')
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount}}', value);
  }

  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-pr-bundle-item]'));
  var priceEl = root.querySelector('#pr-bp-price');
  var stickyPriceEl = root.querySelector('#pr-bp-sticky-price');
  var basePrice = parseInt((priceEl && priceEl.getAttribute('data-base-price')) || '0', 10);
  var errorEl = root.querySelector('[data-pr-bp-error]');
  var addButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pr-bp-add], [data-pr-bp-buynow]'));
  var qtyInput = root.querySelector('#pr-bp-qty');

  function rowVariants(row) {
    try { return JSON.parse(row.getAttribute('data-variants') || '[]'); } catch (e) { return []; }
  }

  function selectedOptionValues(row) {
    var groups = row.querySelectorAll('.pr-brow__option');
    return Array.prototype.map.call(groups, function (group) {
      var active = group.querySelector('.pr-pill.is-active');
      return active ? active.getAttribute('data-value') : null;
    });
  }

  function findVariant(row) {
    var selected = selectedOptionValues(row);
    if (selected.indexOf(null) !== -1) return null;
    var variants = rowVariants(row);
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = v.options || [];
      var match = opts.length === selected.length && opts.every(function (o, idx) { return o === selected[idx]; });
      if (match) return v;
    }
    return null;
  }

  function cheapestVariantPrice(row) {
    var variants = rowVariants(row);
    return variants.reduce(function (min, v) { return v.price < min ? v.price : min; }, variants[0] ? variants[0].price : 0);
  }

  // Task: variant image swap. data-variant-images on each row is a JSON array of
  // "variantId::url" pairs (see sections/pr-bundle-product.liquid) — parsed once per row
  // and cached, since it doesn't change after render.
  var rowImageCache = new WeakMap();
  function rowVariantImages(row) {
    if (rowImageCache.has(row)) return rowImageCache.get(row);
    var map = {};
    try {
      JSON.parse(row.getAttribute('data-variant-images') || '[]').forEach(function (pair) {
        var i = pair.indexOf('::');
        if (i === -1) return;
        var url = pair.slice(i + 2);
        if (url) map[pair.slice(0, i)] = url;
      });
    } catch (e) {}
    rowImageCache.set(row, map);
    return map;
  }

  function updateTotalPrice() {
    if (!priceEl) return;
    var delta = 0;
    rows.forEach(function (row) {
      if (row.getAttribute('data-affects-price') !== 'true') return;
      var variant = findVariant(row);
      if (!variant) return;
      delta += variant.price - cheapestVariantPrice(row);
    });
    var total = basePrice + delta;
    priceEl.textContent = formatMoney(total, moneyFormat);
    if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(total, moneyFormat);
  }

  // Main product gallery lives outside this section (native theme media-gallery, rendered
  // by templates/product.bundle.json's "main" section) — swap its hero image directly
  // rather than through the native variant-picker events, since this buybox has its own
  // decoupled per-item pickers instead of a single native variant selector.
  function setMainGalleryImage(url) {
    if (!url) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var imgs = gallery.querySelectorAll('img.product-media__image');
    imgs.forEach(function (img) {
      img.srcset = '';
      img.sizes = '';
      img.src = url;
    });
    // Task 4: bring the hero image into view so the shopper actually sees the color they
    // just picked — the per-item pickers sit below the gallery, so on mobile especially the
    // swapped image happens off-screen and looks like nothing happened without this.
    if (typeof gallery.scrollIntoView === 'function') {
      gallery.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // Task 3 (variant image swap): each row's own mini thumbnail updates immediately when
  // its color/size changes, sourced from data-variant-images (see the .liquid file) — and,
  // once the shopper has actually picked something (not on the initial page-load pass, or
  // every row would fight over the hero image before anyone touched anything), the same
  // image becomes the page's main hero image too, whichever row changed.
  function updateRow(row, isInitial) {
    var variant = findVariant(row);
    var hidden = row.querySelector('[data-item-variant-id]');
    if (variant) {
      if (hidden) hidden.value = variant.id;
      row.classList.toggle('is-unavailable', !variant.available);

      var url = rowVariantImages(row)[variant.id];
      if (url) {
        var media = row.querySelector('.pr-brow__media img');
        if (media) media.src = url;
        if (!isInitial) setMainGalleryImage(url);
      }
    } else {
      row.classList.add('is-unavailable');
    }
  }

  function allRowsReady() {
    return rows.every(function (row) {
      var variant = findVariant(row);
      return variant && variant.available;
    });
  }

  function refreshAddButtonState() {
    var ready = allRowsReady();
    addButtons.forEach(function (btn) {
      if (btn.getAttribute('data-out-of-stock') === 'true') return; // bundle itself unavailable — leave disabled
      btn.disabled = !ready;
    });
    if (errorEl) errorEl.classList.toggle('is-visible', !ready && rows.length > 0);
  }

  root.addEventListener('click', function (e) {
    var pill = e.target.closest('.pr-pill');
    if (!pill || !root.contains(pill)) return;
    var group = pill.closest('.pr-brow__option');
    group.querySelectorAll('.pr-pill').forEach(function (p) { p.classList.remove('is-active'); });
    pill.classList.add('is-active');
    var row = pill.closest('[data-pr-bundle-item]');
    updateRow(row);
    updateTotalPrice();
    refreshAddButtonState();
  });

  rows.forEach(function (row) { updateRow(row, true); });
  refreshAddButtonState();

  // Quantity stepper
  if (qtyInput) {
    root.querySelector('[data-pr-bp-qty-minus]').addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    root.querySelector('[data-pr-bp-qty-plus]').addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });
  }

  function buildCartItem() {
    var mainBtn = root.querySelector('#pr-bp-add-btn');
    var variantId = mainBtn.getAttribute('data-variant-id');
    var handle = mainBtn.getAttribute('data-product-handle');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var properties = { _bundle: handle };
    rows.forEach(function (row) {
      var variant = findVariant(row);
      if (!variant) return;
      var label = row.getAttribute('data-item-label');
      var itemQty = row.getAttribute('data-item-qty');
      var value = variant.title;
      if (itemQty && parseInt(itemQty, 10) > 1) value += ' (× ' + itemQty + ')';
      properties[label] = value;
    });
    return { id: parseInt(variantId, 10), quantity: qty, properties: properties };
  }

  function handleAdd(redirectToCheckout) {
    if (!allRowsReady()) {
      refreshAddButtonState();
      if (errorEl) errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var item = buildCartItem();
    addButtons.forEach(function (btn) { btn.classList.add('is-loading'); btn.disabled = true; });

    window.PRCart.add([item], {
      successMessage: '✓ "' + (root.querySelector('#pr-bp-add-btn').getAttribute('data-product-title') || '') + '" נוסף לעגלה',
      silentToast: redirectToCheckout,
    }).then(function (result) {
      addButtons.forEach(function (btn) { btn.classList.remove('is-loading'); });
      refreshAddButtonState();
      if (result.ok && redirectToCheckout) window.location.href = '/checkout';
    });
  }

  addButtons.forEach(function (btn) {
    btn.addEventListener('click', function () { handleAdd(false); });
  });
  var buyNowBtn = root.querySelector('[data-pr-bp-buynow]');
  if (buyNowBtn) buyNowBtn.addEventListener('click', function () { handleAdd(true); });

  // Sticky mobile bar — appears once the main add-to-cart button scrolls out of view
  var sticky = root.querySelector('[data-pr-bp-sticky]');
  var mainBtn = root.querySelector('#pr-bp-add-btn');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { sticky.classList.toggle('is-visible', !entry.isIntersecting); });
    }, { threshold: 0 }).observe(mainBtn);
  }
})();
